<template>
    <div>
        <hd-header></hd-header>
        <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 50px;padding-top: 50px;">
            <div style="width:1200px">
                <el-container style="padding-top: 50px;">
                    <el-aside width="220px">
                        <hd-aside></hd-aside>
                    </el-aside>
                    <el-main style="padding-top: 0;padding-bottom: 0;">
                        <el-card shadow="never" style="border: 0;height: 100%;">
                            <p class="pTitle">主页设置</p>
                            <div v-if="userInfo.is_teacher">
                                <p class="pTitleWithoutBorder" style="margin-top: 30px;">主讲课程<span>（只可以添加一个）</span></p>
                                <el-button type="primary" plain="plain" size="mini" @click="addCourse">点击选择</el-button>
                                <div>
                                    <sub-course-detail v-if="form.main_course_id > 0" :name="courseInfo.course_name"
                                                       :type="courseInfo.mode"
                                                       :score="courseInfo.score"
                                                       :totalClass="courseInfo.hour"
                                                       :startYmd="courseInfo.create_time"
                                                       :desc="courseInfo.background"
                                                       :courseImage="courseInfo.cover"></sub-course-detail>
                                </div>
                                <p class="pTitleWithoutBorder" style="margin-top: 30px;">
                                    精选课程<span>（开启后，在您的个人主页将会展示精选课程）</span></p>
                                <el-switch v-model="form.primary_course" @change="setPage" active-color="#13CE66"
                                           active-text="启用"></el-switch>
                                <p class="pTitleWithoutBorder" style="margin-top: 30px;">
                                    学员评价<span>（开启后，在您的个人主页将会展示学员评价）</span></p>
                                <el-switch v-model="form.student_eval" @change="setPage" active-color="#13CE66"
                                           active-text="启用"></el-switch>
                            </div>
                            <div style="margin-top: 20px;" v-if="!userInfo.is_teacher">
                                <el-form v-model="form">
                                    <el-form-item label="个人信息:" class="itemForm">
                                        <el-checkbox v-model="form.school_info" @change="setPage">学校班级</el-checkbox>
                                    </el-form-item>
                                    <el-form-item label="课程信息:" class="itemForm">
                                        <el-checkbox v-model="form.dynamic" @change="setPage">我的动态</el-checkbox>
                                        <el-checkbox v-model="form.course" @change="setPage">我的课程</el-checkbox>
                                    </el-form-item>
                                    <el-form-item label="发表内容:" class="itemForm">
                                        <el-checkbox v-model="form.discuss" @change="setPage">我的讨论</el-checkbox>
                                        <el-checkbox v-model="form.evaluate" @change="setPage">我的评价</el-checkbox>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div style="margin-top: 30px;">
                                <el-button type="primary" style="width: 120px;" size="mini">进入主页</el-button>
                            </div>
                        </el-card>
                    </el-main>
                </el-container>
            </div>
        </div>
        <hd-footer></hd-footer>
        <el-dialog :visible.sync="dialogAddCourse" width="800px">
            <div slot="title">选择主讲课程</div>
            <el-form label-position="right" label-width="100px" style="margin-top: 20px;">
                <el-form-item label="选择课程:">
                    <el-autocomplete placeholder="请选择课程" prefix-icon="iconfont icon-kechengguanli" class="formInput"
                                     :fetch-suggestions="searchCourse" @select="checkedCourse" v-model="courseName"
                                     style="width: 100%;margin-bottom: 0;">
                    </el-autocomplete>
                </el-form-item>
            </el-form>
            <sub-course-detail v-if="courseId > 0" :name="courseInfo.course_name" :type="courseInfo.mode"
                               :score="courseInfo.score"
                               :totalClass="courseInfo.hour"
                               :startYmd="courseInfo.create_time"
                               :desc="courseInfo.background" :courseImage="courseInfo.cover"></sub-course-detail>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="mini" plain="plain" @click="cancelCourse">取消</el-button>
                <el-button type="primary" size="mini" @click="saveCourse">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import HdHeader from '../public/Header.vue'
import HdFooter from '../public/FooterLogined.vue'
import HdAside from '../public/Aside.vue'
import SubCourseDetail from '../public/sub/SubCourseDetail.vue'

export default {
    name: 'UserSetting',
    components: {
        HdHeader,
        HdFooter,
        HdAside,
        SubCourseDetail
    },
    data () {
        return {
            goodsCourse: false,
            evaluate: false,
            dialogAddCourse: false,
            form: {
                id: 0,
                school_info: false,
                dynamic: false,
                course: false,
                discuss: false,
                evaluate: false,
                primary_course: false,
                student_eval: false,
                main_course_id: 0
            },
            courseName: '',
            userInfo: {},
            courseId: 0,
            courseInfo: {}
        }
    },
    created () {
        this.getUserInfo()
        this.getUserPage()
    },
    methods: {
        getUserInfo () {
            let that = this
            this.$ajax.get('/api/user/get').then(function (r) {
                that.userInfo = r.data
            })
        },
        getUserPage () {
            let that = this
            this.$ajax.get('/api/userhomepage/getbyuid').then(function (r) {
                that.form.id = r.data.id
                that.form.school_info = Boolean(r.data.school_info)
                that.form.dynamic = Boolean(r.data.dynamic)
                that.form.course = Boolean(r.data.course)
                that.form.discuss = Boolean(r.data.discuss)
                that.form.evaluate = Boolean(r.data.evaluate)
                that.form.primary_course = Boolean(r.data.primary_course)
                that.form.student_eval = Boolean(r.data.student_eval)
                that.form.main_course_id = Number(r.data.main_course_id)
                console.log('___', that.form.main_course_id)
                if (that.form.main_course_id > 0) {
                    that.$ajax.get('/api/course/get', {
                        params: {
                            id: r.data.main_course_id
                        }
                    }).then(function (r) {
                        that.courseInfo = r.data
                    })
                }
            })
        },
        addCourse () {
            this.dialogAddCourse = true
        },
        cancelCourse () {
            this.dialogAddCourse = false
        },
        pageChangCurrent (page) {
            console.log('pageChangCurrent:', page)
        },
        searchCourse (str, cb) {
            let items = []
            let that = this
            this.$ajax('/api/course/getbyname', {
                params: {
                    name: str
                }
            }).then(function (r) {
                if (r.data.items.length > 0) {
                    r.data.items.forEach(function (each) {
                        items.push({
                            id: each.course_id,
                            value: each.course_name
                        })
                    })
                    cb(items)
                } else {
                    that.showSuccess('未检索到数据')
                }
            })
        },
        checkedCourse (item) {
            this.courseName = item.value
            this.courseId = item.id
            let that = this
            this.$ajax.get('/api/course/get', {
                params: {
                    id: item.id
                }
            }).then(function (r) {
                that.courseInfo = r.data
            })
        },
        setPage () {
            let that = this
            this.$ajax.post('/api/userhomepage/update', this.form).then(function (r) {
                that.showSuccess('保存成功')
            })
        },
        saveCourse () {
            if (this.courseId === 0) {
                this.showError('请选择课程')
                return
            }
            let that = this
            this.$ajax.post('/api/userhomepage/update', {
                id: this.form.id,
                main_course_id: this.courseId
            }).then(function (r) {
                that.showSuccess('保存成功')
                that.dialogAddCourse = false
            })
        }
    }
}
</script>

<style>
body {
    background-color: #F8F8F8;
}

.pTitle {
    font-size: 16px;
    border-bottom: 1px solid #d6d6da;
    padding-bottom: 10px;
}

.pTitle span {
    font-size: 14px;
    color: #999999;
}

.pTitleWithoutBorder {
    font-size: 14px;
    padding-bottom: 10px;
}

.pTitleWithoutBorder span {
    font-size: 14px;
    color: #999999;
}

.pAdd {
    width: 260px;
    height: 160px;
    border: 1px #dcdcdc dashed;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
}

.pAdd:hover {
    border-color: #00a4e0;
}

.pAdd:hover i {
    color: #00a4e0;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserSetting.vue